import { useTranslation } from 'react-i18next';

import { Field } from '../../../shared/ui/Field';
import { Input } from '../../../shared/ui/Input';
import styles from './NotificationsTab.module.css';

interface NotificationsTabProps {
  quietHoursStart: string;
  quietHoursEnd: string;
  maxNotificationsPerDay: number;
  onChange: (
    patch: Partial<{
      quietHoursStart: string;
      quietHoursEnd: string;
      maxNotificationsPerDay: number;
    }>,
  ) => void;
}

// PARA-106, AC-6: тихие часы (пересечение полуночи — валидное состояние,
// см. backend AC-10 правило 3) + максимум уведомлений/день.
export function NotificationsTab({
  quietHoursStart,
  quietHoursEnd,
  maxNotificationsPerDay,
  onChange,
}: NotificationsTabProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <fieldset className={styles.fieldset}>
      <Field label={t('settings.notifications.quietHoursStart')} htmlFor="quiet-hours-start">
        <Input
          id="quiet-hours-start"
          type="time"
          value={quietHoursStart}
          onChange={(event) => onChange({ quietHoursStart: event.target.value })}
        />
      </Field>
      <Field label={t('settings.notifications.quietHoursEnd')} htmlFor="quiet-hours-end">
        <Input
          id="quiet-hours-end"
          type="time"
          value={quietHoursEnd}
          onChange={(event) => onChange({ quietHoursEnd: event.target.value })}
        />
      </Field>
      <Field label={t('settings.notifications.maxPerDay')} htmlFor="max-per-day">
        <Input
          id="max-per-day"
          type="number"
          min={0}
          value={maxNotificationsPerDay}
          onChange={(event) => onChange({ maxNotificationsPerDay: Number(event.target.value) })}
        />
      </Field>
    </fieldset>
  );
}
